import { SystemStyleObject, chakra } from "@chakra-ui/react";

export const filterFooterWrapperCss: SystemStyleObject = {
  height: "78px",
  padding: "24px 16px 10px 16px",
  borderTop: "1px solid #F2F4F7",
};

export const FilterFooterBtn = chakra("button", {
  base: {},
});

export const filterFooterBtnCss: SystemStyleObject = {
  width: "87px",
  height: "44px",
  borderRadius: "8px",
  padding: "10px 18px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "24px",

  "&:disabled": {
    cursor: "not-allowed",
    opacity: 0.5,
  },
};

export const cancelBtnCss: SystemStyleObject = {
  backgroundColor: "transparent",
  color: "#344054",
  border: "1px solid #D0D5DD",
};

export const applyBtnCss: SystemStyleObject = {
  backgroundColor: "#00535C",
  color: "#FFFFFF",
  border: "1px solid #00535C",
  boxShadow: "0px 1px 2px 0px #1018280D",
};

export const loadingBtnCss: SystemStyleObject = {
  width: "130px",
};
